import { useCallback, useMemo, useState } from 'react';

import { OtpContext } from '../OtpContext/OtpContext';
import { OtpContextControllerProps } from '../OtpContext/OtpContext.types';

export const OtpContextController = ({ children, defaultMustReverifyOtp = false }: OtpContextControllerProps) => {
  // Kept above the step so the resend cooldown and the re-verify notice survive the
  // OTP step unmounting (back navigation, or the bounce back from an expired JWT).
  const [otpCooldownEndsAt, setOtpCooldownEndsAt] = useState<number | null>(null);
  const [mustReverifyOtp, setMustReverifyOtp] = useState(defaultMustReverifyOtp);

  const setOtpCooldown = useCallback((seconds: number) => setOtpCooldownEndsAt(Date.now() + seconds * 1000), []);
  const clearOtpCooldown = useCallback(() => setOtpCooldownEndsAt(null), []);

  const value = useMemo(
    () => ({
      otpCooldownEndsAt,
      setOtpCooldown,
      clearOtpCooldown,
      mustReverifyOtp,
      setMustReverifyOtp,
    }),
    [otpCooldownEndsAt, setOtpCooldown, clearOtpCooldown, mustReverifyOtp],
  );

  return <OtpContext.Provider value={value}>{children}</OtpContext.Provider>;
};
